import { useCallback, useRef } from 'react';

import { noop } from 'ui-components/default-props/noop';

// @ts-expect-error typescript-eslint not finding mp3 module
import ErrorSound from '../../../scan/verify/scan-to-verify-body/sounds/error.mp3';
// @ts-expect-error typescript-eslint not finding mp3 module
import SuccessSound from '../../../scan/verify/scan-to-verify-body/sounds/success.mp3';
// @ts-expect-error typescript-eslint not finding mp3 module
import VerificationSound from '../../../scan/verify/scan-to-verify-body/sounds/verification_success.mp3';

export const useScanSound = () => {
  const successAudioRef = useRef<HTMLAudioElement>(new Audio(SuccessSound));
  const failureAudioRef = useRef<HTMLAudioElement>(new Audio(ErrorSound));
  const verifiedAudioRef = useRef<HTMLAudioElement>(new Audio(VerificationSound));
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const play = useCallback((soundType: 'success' | 'error' | 'verified') => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const audioMap = {
      success: successAudioRef.current,
      error: failureAudioRef.current,
      verified: verifiedAudioRef.current,
    };

    timeoutRef.current = setTimeout(() => {
      const audio = audioMap[soundType];
      audio.load();
      audio.play().catch(noop);
    }, 100);
  }, []);

  return play;
};
